import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './style.scss'
import { CloseIcon } from '../../../../assets/icons/Icons';
import PrimaryInput from '../../../../components/inputs/primaryInput';
import { sendApplyEmail } from '../../../../api/apis/email';
import { Spinner } from 'react-bootstrap';

function ApplyForm(props) {

    const [loading, setLoading] = useState(false);
    const [applied, setApplied] = useState(false);
    const [data, setData] = useState({
        firstName: "",
        lastName: "",
        businessName: "",
        website: "",
        businessEmail: "",
    })

    const handleChange = (e) => {
        const { name, value } = e?.target ?? {};
        setData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const clearForm = () => {
        setData({
            firstName: "",
            lastName: "",
            businessName: "",
            website: "",
            businessEmail: "",
        })
    }

    const disabledBtn = !data?.firstName || !data?.lastName || !data?.businessName || !data?.website || !data?.businessEmail

    const handleSave = async () => {
        try {
            setLoading(true);
            const response = await sendApplyEmail(data);
            if (response?.data?.success) {
                clearForm();
                setApplied(true);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const handleClose = () => {
        clearForm();
        props?.onHide && props?.onHide();
        setApplied(false);
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            contentClassName='apply__form'
        >
            <Modal.Body>
                <div className='apply__form__body'>
                    <div className='d-flex w-100 justify-content-end'>
                        <button onClick={handleClose}>
                            <CloseIcon />
                        </button>
                    </div>
                    {
                        applied ?
                            <div className='pb-4'>
                                <h3 className='mb-4'>
                                    Thank you for your inquiry.<br />
                                    We will get back to you shortly.
                                </h3>
                            </div>
                            :
                            <>
                                <div>
                                    <h3>
                                        Apply to Join FlexGrade
                                    </h3>
                                    <p className='body__description'>
                                        Thank you for your interest in the FlexGrade Global Quality Program.
                                        Please leave your contact information; our team will be in touch for next steps.
                                    </p>
                                </div>
                                <div className='input__section'>
                                    <PrimaryInput onChange={handleChange} value={data?.businessName} label={"Business name *"} name={"businessName"} placeholder={"Business Name"} />
                                    <PrimaryInput label={"Website *"} onChange={handleChange} value={data?.website} name={"website"} placeholder={"www.yourwebsite.com "} />
                                    <div className='name__input'>
                                        <PrimaryInput label={"First name *"} onChange={handleChange} name={"firstName"} value={data?.firstName} placeholder={"First Name"} />
                                        <PrimaryInput label={"Last Name *"} onChange={handleChange} name={"lastName"} placeholder={"Last Name"} value={data?.lastName} />
                                    </div>
                                    <PrimaryInput label={"Business Email *"} onChange={handleChange} name={"businessEmail"} placeholder={"example@email.com"} value={data?.businessEmail} />
                                </div>
                            </>
                    }
                </div>
            </Modal.Body>
            {<Modal.Footer className='apply__form__footer'>
                {applied ?
                    <button
                        onClick={handleClose}
                    >
                        Close
                    </button>
                    : <button
                        disabled={disabledBtn}
                        onClick={handleSave}
                    >
                        {loading ? <Spinner animation="border" role="status"></Spinner> : "Submit"}
                    </button>}
            </Modal.Footer>}
        </Modal>
    );
}

export default ApplyForm;